import React from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal, Button } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
import { pTaxActual, pTaxRate } from "../../constants";
class PropertyMuncipalTax extends React.Component {
  countError = "";
  state = {
    escalationIndex: 0,
    currentIndex: null,
    disableOnEdit: false,
    readOnEdit: false,
    showRatesOnarea: [],
    showFirstAddBtn: true,
    disableOnActual: false,
    applicableValue: "",
    propertyTaxBasisValue: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    revalue: "",
    to: "",
    from: "",
    showPtaxCapped: false,
    showAddBtn: false,
    isOpen: false,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    redirect: false,
    propertyTaxDetails: [],
    pTaxLogicValues: [],
    propertyTaxBasisRate: false,
    propertyTaxBasisPureRevenueShare: false,
    propertyTaxBasisPureRevenueShareSalesRange: false,
    propertyTaxBasisPercentofRent: false,
    propertyTaxBasisVouchers: false,
    initialValues: {
      pTaxLogic: {
        propertyTaxBasis: "",
        pTaxLogicValue: "",
        pTaxLogicText: "",
        period: "",
        fromDate: "",
        toDate: "",
        pTaxUom: "",
        pTaxDueDate: "",
        pTaxRate: "",
        pTaxRateTerm: "",
        onArea: "",
        pTaxFrequency: "",
        pTaxCapped: "",
        pTaxCappedOnArea: "",
        rentUom: "",
        rentRate: "",
        percentageofRent: "",
        voucherType: "",
        voucherAmount: "",
        slabs: [],
        rates: [],
      },
      totalSlabs: "",
    },
    showForm: true,
    togglepTaxForm: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  addRatesRow = () => {
    if (this.state.initialValues.pTaxLogic.rates === undefined) {
      this.state.initialValues.pTaxLogic.rates = [];
      this.state.initialValues.pTaxLogic.rates.push({
        from: "",
        to: "",
        pTaxUom: "",
        onArea: "",
        rate: "",
      });
    } else {
      this.state.initialValues.pTaxLogic.rates.push({
        from: "",
        to: "",
        pTaxUom: "",
        onArea: "",
        rate: "",
      });
    }
    if (this.state.initialValues.pTaxLogic.rates.length > 0) {
      this.setState({ showFirstAddBtn: false });
    }
    this.setState({});
  };

  getRatesFromForNextSlab(e, values, index) {
    this.state.initialValues.pTaxLogic.rates[index + 1].from = getToDate(
      e.target.value,
      2,
      0,
      0
    );
    this.setState({});
  }

  showRatesOnarea(e, i) {
    let index = i;
    if (e.target.value == "Per Sq Ft") {
      var _showRatesOnArea = this.state.showRatesOnarea;
      _showRatesOnArea[i] = true;
      this.setState({ showRatesOnarea: _showRatesOnArea });
    } else {
      var _showRatesOnArea = this.state.showRatesOnarea;
      _showRatesOnArea[i] = false;
      this.setState({ showRatesOnarea: _showRatesOnArea });
    }
  }

  removeRatesRow(element) {
    this.state.initialValues.pTaxLogic.rates.splice(element, 1);
    if (this.state.initialValues.pTaxLogic.rates.length == 0) {
      this.setState({ showFirstAddBtn: true });
    }
    this.setState({});
  }

  getpTaxLogicValues(e) {
    if (e.target.value == "Property Tax Basis Rate") {
      this.setState({ pTaxLogicValues: pTaxRate, disableOnActual: false });
    } else if (e.target.value == "Property Tax Basis Actuals") {
      this.setState({ pTaxLogicValues: pTaxActual, disableOnActual: true });
    } else {
      this.setState({ pTaxLogicValues: [] });
    }
  }

  changePTaxCapped(e) {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value == "yes") {
      this.setState({
        showPtaxCapped: true,
      });
    } else {
      this.setState({
        showPtaxCapped: false,
      });
    }
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  editProperty(index, values) {
    this.state.currentIndex = index;
    if (
      this.state.propertyTaxDetails[index].rates !== undefined &&
      this.state.propertyTaxDetails[index].rates.length > 0
    ) {
      this.setState({ showFirstAddBtn: false });
    } else {
      this.setState({ showFirstAddBtn: true });
    }
    if (this.state.propertyTaxDetails[index].ptaxCapped == "yes") {
      this.setState({ showPtaxCapped: true });
    } else {
      this.setState({ showPtaxCapped: false });
    }
    // this.state.showFirstAddBtn = true;
    this.state.readOnEdit = true;
    this.state.disableOnEdit = false;
    this.state.period = this.state.propertyTaxDetails[index].period;
    this.state.initialValues.totalSlabs =
      this.state.propertyTaxDetails[index].slabNumber;
    this.state.propertyTaxBasisValue =
      this.state.propertyTaxDetails[index].propertyTaxBasis;
    if (this.state.propertyTaxBasisValue == "Property Tax Basis Rate") {
      this.setState({ pTaxLogicValues: pTaxRate, disableOnActual: false });
    } else if (
      this.state.propertyTaxBasisValue == "Property Tax Basis Actuals"
    ) {
      this.setState({ pTaxLogicValues: pTaxActual, disableOnActual: true });
    } else {
      this.setState({ pTaxLogicValues: [] });
    }
    // this.state.initialValues.pTaxLogic.pTaxLogicValue =
    //   this.state.propertyTaxDetails[index].pTaxLogicValue;
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.propertyTaxDetails[index].periodTermDD,
      periodTermMM: this.state.propertyTaxDetails[index].periodTermMM,
      periodTermYY: this.state.propertyTaxDetails[index].periodTermYY,
    });
    if (this.state.propertyTaxDetails[index].pTaxLogicValue === "1") {
      this.setState({
        propertyTaxBasisRate: true,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    } else if (this.state.propertyTaxDetails[index].pTaxLogicValue === "2") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: true,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    } else if (this.state.propertyTaxDetails[index].pTaxLogicValue === "3") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: true,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    } else if (this.state.propertyTaxDetails[index].pTaxLogicValue === "4") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: true,
        propertyTaxBasisVouchers: false,
      });
    } else if (this.state.propertyTaxDetails[index].pTaxLogicValue === "5") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: true,
      });
    } else {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    }
    values.pTaxLogic = { ...this.state.propertyTaxDetails[index] };
    this.state.fromDate = this.state.propertyTaxDetails[index].fromDate;
    this.state.toDate = this.state.propertyTaxDetails[index].toDate;
    if (this.state.propertyTaxDetails[index].camActualization == "Yes") {
      this.setState({ showCamActalization: true });
    } else {
      this.setState({ showCamActalization: false });
    }
    if (this.state.propertyTaxDetails[index].camCapped == "Yes") {
      this.setState({ showCamCapped: true });
    } else {
      this.setState({ showCamCapped: false });
    }
    this.setState({});
  }

  addpTaxDetails = (values, resetForm, setFieldValue) => {
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      } else if (this.state.toDate == values.to) {
        this.state.showForm = false;
        this.state.showAddBtn = false;
      }
      values.propertyTaxPayable = this.state.applicableValue;
      values.pTaxLogic.propertyTaxBasis = this.state.propertyTaxBasisValue;
      values.pTaxLogic.pTaxLogicText =
        this.state.initialValues.pTaxLogic.pTaxLogicText;
      var _propertyTaxDetails = this.state.propertyTaxDetails;
      values.pTaxLogic.period = this.state.period;
      values.pTaxLogic.fromDate = this.state.fromDate;
      values.pTaxLogic.toDate = this.state.toDate;
      values.pTaxLogic.periodTermYY = this.state.periodTermYY;
      values.pTaxLogic.periodTermMM = this.state.periodTermMM;
      values.pTaxLogic.periodTermDD = this.state.periodTermDD;
      _propertyTaxDetails.push(values.pTaxLogic);
      var _initialValues = this.state.initialValues;
      // _initialValues.pTaxLogic.pTaxLogicValue = "";
      _initialValues.totalSlabs = 0;
      this.setState({
        propertyTaxDetails: _propertyTaxDetails,
        // propertyTaxBasisRate: false,
        // propertyTaxBasisPureRevenueShare: false,
        // propertyTaxBasisPureRevenueShareSalesRange: false,
        // propertyTaxBasisPercentofRent: false,
        // propertyTaxBasisVouchers: false,
      });
      this.state.initialValues.pTaxLogic.slabs = [];
      this.state.initialValues.pTaxLogic.rates = [];
      // this.state.initialValues.pTaxLogic.pTaxLogicValue = "";
      this.state.period++;
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.propertyTaxDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      setFieldValue("pTaxLogic.pTaxRate", "");
      setFieldValue("pTaxLogic.escalationPercent", "");
      this.setState({ isEdit: false, escalationIndex: this.state.period - 2 });
    } else {
      if (!this.validator.allValid()) {
        console.log(this.validator);
        this.validator.showMessages();
        return false;
      }
      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      } else if (this.state.toDate == values.to) {
        this.state.showForm = false;
        this.state.showAddBtn = false;
      }
      values.propertyTaxPayable = this.state.applicableValue;
      values.pTaxLogic.propertyTaxBasis = this.state.propertyTaxBasisValue;
      values.pTaxLogic.pTaxLogicText =
        this.state.initialValues.pTaxLogic.pTaxLogicText;
      var _propertyTaxDetails = this.state.propertyTaxDetails;
      values.pTaxLogic.period = this.state.period;
      values.pTaxLogic.fromDate = this.state.fromDate;
      values.pTaxLogic.toDate = this.state.toDate;
      values.pTaxLogic.periodTermYY = this.state.periodTermYY;
      values.pTaxLogic.periodTermMM = this.state.periodTermMM;
      values.pTaxLogic.periodTermDD = this.state.periodTermDD;
      _propertyTaxDetails[this.state.currentIndex] = { ...values.pTaxLogic };
      var _initialValues = this.state.initialValues;
      _initialValues.pTaxLogic.pTaxLogicValue = "";
      _initialValues.totalSlabs = 0;
      this.setState({
        propertyTaxDetails: _propertyTaxDetails,
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
      console.log(this.state.initialValues);
      this.state.initialValues.pTaxLogic.slabs = [];
      this.state.initialValues.pTaxLogic.rates = [];
      this.state.initialValues.pTaxLogic.pTaxLogicValue = "";
      this.state.period++;
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.propertyTaxDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      resetForm();
      this.state.currentIndex = null;
      this.state.disableOnEdit = false;
      this.state.readOnEdit = false;
      this.setState({ isEdit: false, escalationIndex: this.state.period - 1 });
    }
  };

  resetpTaxDetails = (values, resetForm) => {
    var _initialValues = this.state.initialValues;
    _initialValues.pTaxLogic.pTaxLogicValue = "";
    _initialValues.totalSlabs = 0;
    this.setState({
      // propertyTaxDetails: _propertyTaxDetails,
      propertyTaxBasisRate: false,
      propertyTaxBasisPureRevenueShare: false,
      propertyTaxBasisPureRevenueShareSalesRange: false,
      propertyTaxBasisPercentofRent: false,
      propertyTaxBasisVouchers: false,
    });
    console.log(this.state.initialValues);
    this.state.initialValues.pTaxLogic.slabs = [];
    this.state.initialValues.pTaxLogic.rates = [];
    this.state.initialValues.pTaxLogic.pTaxLogicValue = "";
    this.state.period++;
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.propertyTaxDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
    resetForm();
    this.state.currentIndex = null;
    this.state.disableOnEdit = false;
    this.state.readOnEdit = false;
    this.setState({});
  };


  handleReset = () => {
    var _initialValues = this.state.initialValues;
    _initialValues.pTaxLogic.pTaxLogicValue = "";
    _initialValues.totalSlabs = 0;
    this.setState({
      // propertyTaxDetails: _propertyTaxDetails,
      propertyTaxBasisRate: false,
      propertyTaxBasisPureRevenueShare: false,
      propertyTaxBasisPureRevenueShareSalesRange: false,
      propertyTaxBasisPercentofRent: false,
      propertyTaxBasisVouchers: false,
    });
    console.log(this.state.initialValues);
    this.state.initialValues.pTaxLogic.slabs = [];
    this.state.initialValues.pTaxLogic.rates = [];
    this.state.initialValues.pTaxLogic.pTaxLogicValue = "";
    this.state.period++;
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.propertyTaxDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
    this.state.currentIndex = null;
    this.state.disableOnEdit = false;
    this.state.readOnEdit = false;
    this.setState({});
  };

  addSlabRow = (e) => {
    this.state.initialValues.totalSlabs = e.target.value;
    if (this.state.initialValues.pTaxLogic.slabs.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.pTaxLogic.slabs.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.pTaxLogic.slabs.push({
          from: "",
          to: "",
          percent: "",
        });
      }
    } else if (
      this.state.initialValues.pTaxLogic.slabs.length > e.target.value
    ) {
      var toRemove =
        this.state.initialValues.pTaxLogic.slabs.length - e.target.value;
      for (var i = 0; i < toRemove; i++) {
        this.state.initialValues.pTaxLogic.slabs.pop({});
      }
    }
  };

  getFromForNextSlab(e, values, index) {
    this.state.initialValues.pTaxLogic.slabs[index + 1].from =
      Number(e.target.value) + Number(1);
    this.setState({});
  }

  showpTaxForm = (e) => {
    if (e.target.value === "yes") {
      this.setState({
        togglepTaxForm: true,
      });
    } else {
      this.setState({
        togglepTaxForm: false,
      });
    }
  };

  hadlepTaxLogicChange = (event) => {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (event.target.value === "") {
      this.state.showAddBtn = false;
    } else {
      this.state.showAddBtn = true;
    }
    var index = event.nativeEvent.target.selectedIndex;
    var text = event.nativeEvent.target[index].label;
    this.state.initialValues.pTaxLogic.pTaxLogicText = text;
    this.state.initialValues.pTaxLogic.pTaxLogicValue = event.target.value;
    if (event.target.value === "1") {
      this.setState({
        propertyTaxBasisRate: true,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    } else if (event.target.value === "2") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: true,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    } else if (event.target.value === "3") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: true,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    } else if (event.target.value === "4") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: true,
        propertyTaxBasisVouchers: false,
      });
    } else if (event.target.value === "5") {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: true,
      });
    } else {
      this.setState({
        propertyTaxBasisRate: false,
        propertyTaxBasisPureRevenueShare: false,
        propertyTaxBasisPureRevenueShareSalesRange: false,
        propertyTaxBasisPercentofRent: false,
        propertyTaxBasisVouchers: false,
      });
    }
  };

  componentDidMount() {

    let athis=this;
    axios({
      url:`${apiUrl.apiUrl.url}/create-lease/fetch-lease-property-tax-details?id=${this.props.match.params.id}`,
      method: 'GET'
    }).then(function (response){
      let data = response.data;
      athis.state.to = data.to;
        athis.state.fromDate = data.from;
        athis.state.applicableValue = data.propertyTaxPayable;
        if (data.propertyTaxDetails.length > 0) {
          athis.setState({
            fromDate: getToDate(
              data.propertyTaxDetails[data.propertyTaxDetails.length - 1]
                .toDate,
              2,
              0,
              0
            ),
          });
        }
        athis.setState({
          initialValues: data,
          propertyTaxDetails: data.propertyTaxDetails,
          renewalLeaseTermDD: data.renewalLeaseTermDD,
          renewalLeaseTermMM: data.renewalLeaseTermMM,
          renewalLeaseTermYY: data.renewalLeaseTermYY,
          leaseTermDD: data.leaseTermDD,
          leaseTermMM: data.leaseTermMM,
          leaseTermYY: data.leaseTermYY,
          period:
            data.propertyTaxDetails.length > 0
              ? data.propertyTaxDetails.length + 1
              : 1,
        });
        if (data.propertyTaxPayable == "yes") {
          athis.setState({
            togglepTaxForm: true,
          });
        } else {
          athis.setState({
            togglepTaxForm: false,
          });
        }
        if (
          data.propertyTaxDetails[data.propertyTaxDetails.length - 1].toDate ==
          data.to
        ) {
          athis.setState({
            showForm: false,
          });
        }
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-property-tax-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.to = data.to;
    //     this.state.fromDate = data.from;
    //     this.state.applicableValue = data.propertyTaxPayable;
    //     if (data.propertyTaxDetails.length > 0) {
    //       // let _tempDate = new Date(
    //       //   data.propertyTaxDetails[data.propertyTaxDetails.length - 1].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.propertyTaxDetails[data.propertyTaxDetails.length - 1]
    //             .toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       propertyTaxDetails: data.propertyTaxDetails,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       period:
    //         data.propertyTaxDetails.length > 0
    //           ? data.propertyTaxDetails.length + 1
    //           : 1,
    //     });
    //     if (data.propertyTaxPayable == "yes") {
    //       this.setState({
    //         togglepTaxForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         togglepTaxForm: false,
    //       });
    //     }
    //     if (
    //       data.propertyTaxDetails[data.propertyTaxDetails.length - 1].toDate ==
    //       data.to
    //     ) {
    //       this.setState({
    //         showForm: false,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _pTax = this.state.propertyTaxDetails;
    _pTax.splice(this.state.index_val, 1);
    console.log(_pTax, "new array");
    this.setState({
      propertyTaxDetails: _pTax,
      showForm: true,
    });
    this.state.period--;
    if (this.state.propertyTaxDetails.length > 0) {
      this.setState({
        fromDate: getToDate(
          this.state.propertyTaxDetails[
            this.state.propertyTaxDetails.length - 1
          ].toDate,
          2,
          0,
          0
        ),
      });
    } else {
      this.setState({
        fromDate: this.state.revalue,
      });
    }
    this.setState({
      delete: false,
      index_val: "",
      revalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  calculateRentRate(e, values, setFieldValue) {
    if (this.state.period > 1) {
      setFieldValue(
        "pTaxLogic.pTaxRate",
        (
          Number(
            this.state.propertyTaxDetails[
              this.state.propertyTaxDetails.length - 1
            ].pTaxRate
          ) *
          (1 + Number(e.target.value) / 100)
        ).toFixed(2)
      );
    }
  }

  calculateEscalationPercent(e, values, setFieldValue) {
    if (
      this.state.period > 1 &&
      this.state.propertyTaxDetails[this.state.escalationIndex].pTaxRate !== 0
    ) {
      setFieldValue(
        "pTaxLogic.escalationPercent",
        ((Number(e.target.value) -
          Number(
            this.state.propertyTaxDetails[this.state.escalationIndex].pTaxRate
          )) /
          Number(
            this.state.propertyTaxDetails[
              this.state.propertyTaxDetails.length - 1
            ].pTaxRate
          )) *
        100
      );
    }
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={
            "/createlease/parking-storage-signage/" + this.props.match.params.id
          }
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Other Charges</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Property & Municipal Tax Fund</a>
                  </li>
                </ul>
              </div>
            </div>

            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                this.state.applicableValue = this.state.applicableValue;
                values.propertyTaxPayable = this.state.applicableValue;
                if (!this.applicableValidator.allValid()) {
                  console.log(this.validator);
                  this.applicableValidator.showMessages();
                  return false;
                }
                console.log(values);
                if (
                  this.state.propertyTaxDetails.length == 0 &&
                  this.state.applicableValue !== "no"
                ) {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                // if (
                //   this.state.applicableValue == "yes" &&
                //   this.state.to !==
                //     this.state.propertyTaxDetails[
                //       this.state.propertyTaxDetails.length - 1
                //     ].toDate
                // ) {
                //   this.setState({
                //     popupalertMessage: true,
                //     popupMessageContent: "Please Complete the period",
                //   });
                //   // alert("Please Complete the period ");
                //   return false;
                // }
                values.propertyTaxDetails = this.state.propertyTaxDetails;
                console.log(values.propertyTaxDetails, "gg");
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-property-tax-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <>

                  <div className="unitFormContainerNew">
                    <Form autoComplete="off">
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Lease Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />

                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />

                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                  />

                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                  />

                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                  />

                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              From
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="from" />
                              <ErrorMessage
                                name="from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              To
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="to" />
                              <ErrorMessage
                                name="to"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Property Tax Payable By <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="propertyTaxPayable"
                                value={this.state.applicableValue}
                                onChange={(e) => {
                                  this.state.applicableValue = e.target.value;
                                  handleChange(e);
                                  this.showpTaxForm(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="yes" label="Occupier" />
                                <option value="no" label="Landlord" />
                              </Field>
                              {this.applicableValidator.message(
                                "Property Tax Payable By",
                                this.state.applicableValue,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          {this.state.togglepTaxForm && (
                            <div className="newGridSectionInner">
                              <label>
                                Property Tax Bases <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as="select"
                                  name="pTaxLogic.propertyTaxBasis"
                                  value={this.state.propertyTaxBasisValue}
                                  disabled={this.state.disableOnEdit}
                                  onChange={(e) => {
                                    this.getpTaxLogicValues(e);
                                    this.state.propertyTaxBasisValue = e.target.value;
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option value="Property Tax Basis Rate" label="Property Tax Basis Rate" />
                                  <option value="Property Tax Basis Actuals" label="Property Tax Basis Actuals" />
                                </Field>
                                {this.validator.message(
                                  "Property Tax Bases",
                                  this.state.propertyTaxBasisValue,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                          )}

                          {this.state.togglepTaxForm && (
                            <>
                              {this.state.showForm && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Period
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="pTaxLogic.period"
                                        disabled={this.state.disableOnEdit}
                                        value={this.state.period}
                                        onChange={(e) => {
                                          this.state.period = e.target.value;
                                        }}
                                      />
                                      <ErrorMessage
                                        name="pTaxLogic.period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Period Term
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-4 p-0">
                                          <Field
                                            type="text"
                                            name="periodTermYY"
                                            placeholder="YY"
                                            disabled={this.state.disableOnEdit}
                                            className="centerPlaceHolder text-center"
                                            value={this.state.periodTermYY}
                                            onChange={(e) => {
                                              this.state.periodTermYY = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-4">
                                          <Field
                                            type="text"
                                            name="periodTermMM"
                                            placeholder="MM"
                                            disabled={this.state.disableOnEdit}
                                            className="centerPlaceHolder text-center"
                                            value={this.state.periodTermMM}
                                            onChange={(e) => {
                                              this.state.periodTermMM = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-4 p-0">
                                          <Field
                                            type="text"
                                            name="periodTermDD"
                                            placeholder="DD"
                                            disabled={this.state.disableOnEdit}
                                            className="centerPlaceHolder text-center"
                                            value={this.state.periodTermDD}
                                            onChange={(e) => {
                                              this.state.periodTermDD = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name="pTaxLogic.periodTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </>
                              )}

                              {this.state.showForm && (
                                <div className="gridColOneByThree">
                                  <div className="newGridSectionInner newGridSectionInnerForLogin">
                                    <label>
                                      Property Tax Logic <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxLogicValue"
                                        disabled={this.state.disableOnEdit}
                                        value={
                                          this.state.initialValues.pTaxLogic.pTaxLogicValue
                                        }
                                        onChange={(e) => {
                                          handleChange(e);
                                          this.hadlepTaxLogicChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        {this.state.pTaxLogicValues.map((item, i) => (
                                          <option key={"pTaxLogicValues" + item} value={i + 1}>
                                            {item}
                                          </option>
                                        ))}
                                      </Field>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {this.state.propertyTaxBasisRate && (
                                <>
                                  {this.state.disableOnActual == false && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="date"
                                            readOnly={true}
                                            name="pTaxLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="date"
                                            readOnly={true}
                                            name="pTaxLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          P TAX UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxUom"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                            <option value="Flat Amount" label="Flat Amount" />
                                          </Field>
                                          {this.validator.message(
                                            "P TAX UOM",
                                            values.pTaxLogic.pTaxUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  {values.pTaxLogic.pTaxUom == "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        On Area
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="pTaxLogic.onArea"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Usable Area" label="Usable Area" />
                                          <option value="Carpet Area" label="Carpet Area" />
                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.pTaxLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  {this.state.period > 1 &&
                                    typeof this.state.propertyTaxDetails[
                                      this.state.escalationIndex
                                    ].pTaxRate !== "undefined" &&
                                    this.state.propertyTaxDetails[
                                      this.state.escalationIndex
                                    ].pTaxRate !== 0 &&
                                    this.state.disableOnActual === false && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          Escalation %
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(e, values, setFieldValue);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.pTaxLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                  {this.state.disableOnActual == false && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        P TAX Rate <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="number"
                                          name="pTaxLogic.pTaxRate"
                                          onBlur={(e) => {
                                            this.calculateEscalationPercent(e, values, setFieldValue);
                                          }}
                                        />
                                        {this.validator.message(
                                          "p Tax Rate",
                                          values.pTaxLogic.pTaxRate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      P TAX Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxRateTerm"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "p Tax Rate Term",
                                        values.pTaxLogic.pTaxRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      P TAX Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxFrequency"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "p Tax Frequency",
                                        values.pTaxLogic.pTaxFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      P TAX Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueDate"
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueType"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueFrequency"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pTaxLogic.pTaxDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Capped <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.ptaxCapped"
                                        onChange={(e) => {
                                          this.changePTaxCapped(e);
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="yes" label="Yes" />
                                        <option value="no" label="No" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Capped",
                                        values.pTaxLogic.ptaxCapped,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.showPtaxCapped && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxCappedUom"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                            <option value="Flat Amount" label="Flat Amount" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Uom",
                                            values.pTaxLogic.pTaxCappedUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      {values.pTaxLogic.pTaxCappedUom === "Per Sq Ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            P Tax Capped on Area <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="pTaxLogic.pTaxCappedOnArea"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped On Area",
                                              values.pTaxLogic.pTaxCappedOnArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped Rate <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.ptaxCappedRate"
                                          />
                                          {this.validator.message(
                                            "P Tax Capped Rate",
                                            values.pTaxLogic.ptaxCappedRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped Rate Term <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.ptaxCappedRateTerm"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Day" label="Per Day" />
                                            <option value="Per Month" label="Per Month" />
                                            <option value="Per Quarter" label="Per Quarter" />
                                            <option value="Per Half Year" label="Per Half Year" />
                                            <option value="Per Year" label="Per Year" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Rate Term",
                                            values.pTaxLogic.ptaxCappedRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  {this.state.disableOnActual && (
                                    <>
                                      {this.state.showFirstAddBtn == true && (
                                        <div className="button_group d-flex justify-content-end">
                                          <button
                                            type="button"
                                            className="add_button"
                                            onClick={(e) => {
                                              this.addRatesRow();
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPlus} />{" "}
                                            Add Rates
                                          </button>
                                        </div>
                                      )}
                                      <div className="gridColOneByThree d-grid gap-4">
                                        {this.state.initialValues.pTaxLogic
                                          .rates !== undefined &&
                                          this.state.initialValues.pTaxLogic.rates.map(
                                            (name, index) => (
                                              <>
                                                <div className="newGridSectionForFormMain" key={index}>
                                                  <div className="newGridSectionInner">
                                                    <label>From</label>
                                                    <div className="position-relative">
                                                      <Field
                                                        type="date"
                                                        name={`pTaxLogic.rates.${index}.from`}
                                                        onChange={(e) => {
                                                          this.state.initialValues.pTaxLogic.rates[index].from = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={this.state.initialValues.pTaxLogic.rates[index].from}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="newGridSectionInner">
                                                    <label>To</label>
                                                    <div className="position-relative">
                                                      <Field
                                                        type="date"
                                                        name={`pTaxLogic.rates.${index}.to`}
                                                        value={this.state.initialValues.pTaxLogic.rates[index].to}
                                                        onChange={(e) => {
                                                          this.state.initialValues.pTaxLogic.rates[index].to = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        onBlur={(e) => {
                                                          console.log("hh");
                                                          if (index < this.state.initialValues.pTaxLogic.rates.length - 1) {
                                                            this.getRatesFromForNextSlab(e, values, index);
                                                          }
                                                        }}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="newGridSectionInner">
                                                    <label>P TAX UOM</label>
                                                    <div className="position-relative">
                                                      <Field
                                                        as="select"
                                                        name={`pTaxLogic.rates.${index}.pTaxUom`}
                                                        onChange={(e) => {
                                                          this.showRatesOnarea(e, index);
                                                          this.state.initialValues.pTaxLogic.rates[index].pTaxUom = e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={this.state.initialValues.pTaxLogic.rates[index].pTaxUom}
                                                      >
                                                        <option value="" label="Select" defaultValue />
                                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                                        <option value="Flat Amount" label="Flat Amount" />
                                                      </Field>
                                                    </div>
                                                  </div>

                                                  {this.state.showRatesOnarea[index] !== undefined && this.state.showRatesOnarea[index] && (
                                                    <div className="newGridSectionInner">
                                                      <label>On Area</label>
                                                      <div className="position-relative">
                                                        <Field
                                                          as="select"
                                                          name={`pTaxLogic.rates.${index}.onArea`}
                                                          onChange={(e) => {
                                                            this.state.initialValues.pTaxLogic.rates[index].onArea = e.target.value;
                                                            handleChange(e);
                                                          }}
                                                          value={this.state.initialValues.pTaxLogic.rates[index].onArea}
                                                        >
                                                          <option value="" label="Select" defaultValue />
                                                          <option value="Usable Area" label="Usable Area" />
                                                          <option value="Carpet Area" label="Carpet Area" />
                                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                                        </Field>
                                                      </div>
                                                    </div>
                                                  )}

                                                  <div className="newGridSectionInner">
                                                    <label>Rate</label>
                                                    <div className="position-relative d-flex gap-2 align-items-center">
                                                      <Field type="number" name={`pTaxLogic.rates.${index}.rate`} />
                                                      <span
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={(e) => {
                                                          this.addRatesRow();
                                                        }}
                                                      >
                                                        <FontAwesomeIcon icon={faPlus} />
                                                      </span>
                                                      <span
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={(e) => {
                                                          this.removeRatesRow();
                                                        }}
                                                      >
                                                        <FontAwesomeIcon icon={faTrashAlt} color="red" />
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )
                                          )}
                                      </div>
                                    </>
                                  )}
                                </>
                              )}

                              {this.state.propertyTaxBasisPureRevenueShare && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>From <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pTaxLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>To <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pTaxLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>P Tax Revenue Share (%) <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        name="pTaxLogic.revenueShare"
                                        type="number"
                                      />
                                      {this.validator.message(
                                        "Revenue Share",
                                        values.pTaxLogic.revenueShare,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>P TAX Rate Term <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"pTaxLogic.pTaxRateTerm"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "p Tax Rate Term",
                                        values.pTaxLogic.pTaxRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>P TAX Frequency <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"pTaxLogic.pTaxFrequency"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "p Tax Frequency",
                                        values.pTaxLogic.pTaxFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>P TAX Due Date <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.pTaxDueDate"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxDueType"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxDueFrequency"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pTaxLogic.pTaxDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>P Tax Capped <span className="astrik">*</span></label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"pTaxLogic.ptaxCapped"}
                                        onChange={(e) => {
                                          this.changePTaxCapped(e);
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="yes" label="Yes" />
                                        <option value="no" label="No" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Capped",
                                        values.pTaxLogic.ptaxCapped,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.showPtaxCapped && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>P Tax Capped UOM <span className="astrik">*</span></label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxCappedUom"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                            <option value="Flat Amount" label="Flat Amount" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Uom",
                                            values.pTaxLogic.pTaxCappedUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      {values.pTaxLogic.pTaxCappedUom === "Per Sq Ft" && (
                                        <div className="newGridSectionInner">
                                          <label>P Tax Capped on Area <span className="astrik">*</span></label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="pTaxLogic.pTaxCappedOnArea"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped On Area",
                                              values.pTaxLogic.pTaxCappedOnArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div className="newGridSectionInner">
                                        <label>P Tax Capped Rate <span className="astrik">*</span></label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.ptaxCappedRate"
                                          />
                                          {this.validator.message(
                                            "P Tax Capped Rate",
                                            values.pTaxLogic.ptaxCappedRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>P Tax Capped Rate Term <span className="astrik">*</span></label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.ptaxCappedRateTerm"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Day" label="Per Day" />
                                            <option value="Per Month" label="Per Month" />
                                            <option value="Per Quarter" label="Per Quarter" />
                                            <option value="Per Half Year" label="Per Half Year" />
                                            <option value="Per Year" label="Per Year" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Rate Term",
                                            values.pTaxLogic.ptaxCappedRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}

                              {this.state
                                .propertyTaxBasisPureRevenueShareSalesRange && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>From <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <Field
                                          type="date"
                                          name="pTaxLogic.fromDate"
                                          value={this.state.fromDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "From",
                                          this.state.fromDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>To <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <Field
                                          type="date"
                                          name="pTaxLogic.toDate"
                                          value={this.state.toDate}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        />
                                        {this.validator.message(
                                          "To",
                                          this.state.toDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>P Tax Revenue Share (%)</label>
                                    </div>
                                    <div className="newGridSectionInner"></div>
                                    <div className="newGridSectionInner">
                                      <label>No. of SLABS <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="pTaxLogic.slabNumber"
                                          value={this.state.initialValues.totalSlabs}
                                          className="slabInput"
                                          onChange={(e) => {
                                            this.addSlabRow(e);
                                            handleChange(e);
                                          }}
                                        />
                                        <ErrorMessage
                                          name="pTaxLogic.slabNumber"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>

                                    <div className="gridColOneByThree">
                                      <table className="table tableSimple">
                                        <thead>
                                          <tr>
                                            <th scope="col">SLAB</th>
                                            <th scope="col">FROM</th>
                                            <th scope="col">To</th>
                                            <th scope="col">
                                              P Tax Revenue Share (%)
                                            </th>
                                            <th scope="col" colSpan="">
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.initialValues
                                            .pTaxLogic.slabs.length > 0 &&
                                            this.state.initialValues.pTaxLogic.slabs.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`pTaxLogic.slabs.${index}.from`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.pTaxLogic.slabs[
                                                          index
                                                        ].from =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state
                                                          .initialValues
                                                          .pTaxLogic.slabs[
                                                          index
                                                        ].from
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`pTaxLogic.slabs.${index}.to`}
                                                      onChange={(e) => {
                                                        this.state.initialValues.pTaxLogic.slabs[
                                                          index
                                                        ].to =
                                                          e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      value={
                                                        this.state
                                                          .initialValues
                                                          .pTaxLogic.slabs[
                                                          index
                                                        ].to
                                                      }
                                                      onBlur={(e) => {
                                                        if (
                                                          index <
                                                          this.state
                                                            .initialValues
                                                            .pTaxLogic.slabs
                                                            .length -
                                                          1
                                                        ) {
                                                          this.getFromForNextSlab(
                                                            e,
                                                            values,
                                                            index
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`pTaxLogic.slabs.${index}.percent`}
                                                    />
                                                  </td>
                                                  {/* <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td> */}
                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={() => {
                                                        this.state
                                                          .initialValues
                                                          .totalSlabs--;
                                                        var _slabs =
                                                          this.state
                                                            .initialValues
                                                            .pTaxLogic
                                                            .slabs;
                                                        _slabs.splice(
                                                          index,
                                                          1
                                                        );
                                                        this.setState({
                                                          slabs: _slabs,
                                                        });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>P TAX Rate Term <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="pTaxLogic.pTaxRateTerm"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Per Month" label="Per Month" />
                                          <option value="Per Quarter" label="Per Quarter" />
                                          <option value="Per Half Year" label="Per Half Year" />
                                          <option value="Per Year" label="Per Year" />
                                          <option value="Per Day" label="Per Day" />
                                        </Field>
                                        {this.validator.message(
                                          "p Tax Rate Term",
                                          values.pTaxLogic.pTaxRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>P TAX Frequency <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="pTaxLogic.pTaxFrequency"
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Daily" label="Daily" />
                                          <option value="Monthly" label="Monthly" />
                                          <option value="Quarterly" label="Quarterly" />
                                          <option value="Half Yearly" label="Half Yearly" />
                                          <option value="Yearly" label="Yearly" />
                                        </Field>
                                        {this.validator.message(
                                          "p Tax Frequency",
                                          values.pTaxLogic.pTaxFrequency,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>P TAX Due Date <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <div className="row m-0">
                                          <div className="col-sm-6 ps-0">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.pTaxDueDate"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />

                                          </div>
                                          <div className="col-sm-6 pe-0">
                                            <Field
                                              as="select"
                                              name="pTaxLogic.pTaxDueType"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Date" label="Date" />
                                              <option value="Days" label="Days" />
                                              <option value="Working Day" label="Working Day" />
                                            </Field>

                                          </div>
                                          <div className="col-sm-12 p-0 mt-3">
                                            <Field
                                              as="select"
                                              name="pTaxLogic.pTaxDueFrequency"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Every Month" label="Every Month" />
                                              <option value="Subsequent Month" label="Subsequent Month" />
                                              <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                              <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                              <option value="Subsequent Year" label="Subsequent Year" />
                                              <option value="Next Financial Year" label="Next Financial Year" />
                                            </Field>

                                          </div>
                                        </div>
                                        <div className="newGridSectionInner">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pTaxLogic.pTaxDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="newGridSectionInner">
                                      <label>P Tax Capped <span className="astrik">*</span></label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="pTaxLogic.ptaxCapped"
                                          onChange={(e) => {
                                            this.changePTaxCapped(e);
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="yes" label="Yes" />
                                          <option value="no" label="No" />
                                        </Field>
                                        {this.validator.message(
                                          "P Tax Capped",
                                          values.pTaxLogic.ptaxCapped,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    {this.state.showPtaxCapped && (
                                      <>
                                        <div className="newGridSectionInner">
                                          <label>
                                            P Tax Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxCappedUom"}
                                              onChange={(e) => {
                                                this.validator = new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Per Sq Ft" label="Per Sq Ft" />
                                              <option value="Flat Amount" label="Flat Amount" />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Uom",
                                              values.pTaxLogic.pTaxCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                        {values.pTaxLogic.pTaxCappedUom === "Per Sq Ft" && (
                                          <div className="newGridSectionInner">
                                            <label>
                                              P Tax Capped on Area
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="position-relative">
                                              <Field
                                                as="select"
                                                name={"pTaxLogic.pTaxCappedOnArea"}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                              >
                                                <option value="" label="Select" defaultValue />
                                                <option value="Usable Area" label="Usable Area" />
                                                <option value="Carpet Area" label="Carpet Area" />
                                                <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                              </Field>
                                              {this.validator.message(
                                                "P Tax Capped On Area",
                                                values.pTaxLogic.pTaxCappedOnArea,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        )}
                                        <div className="newGridSectionInner">
                                          <label>
                                            P Tax Capped Rate
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.ptaxCappedRate"
                                            />
                                            {this.validator.message(
                                              "P Tax Capped Rate",
                                              values.pTaxLogic.ptaxCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                        <div className="newGridSectionInner">
                                          <label>
                                            P Tax Capped Rate Term
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.ptaxCappedRateTerm"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Per Day" label="Per Day" />
                                              <option value="Per Month" label="Per Month" />
                                              <option value="Per Quarter" label="Per Quarter" />
                                              <option value="Per Half Year" label="Per Half Year" />
                                              <option value="Per Year" label="Per Year" />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Rate Term",
                                              values.pTaxLogic.ptaxCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}

                              {this.state.propertyTaxBasisPercentofRent && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pTaxLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pTaxLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Rent UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxUom"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="Flat Amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "Rent Uom",
                                        values.pTaxLogic.pTaxUom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  {values.pTaxLogic.pTaxUom === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        On Area
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="pTaxLogic.onArea"
                                          onChange={(e) => handleChange(e)}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Usable Area" label="Usable Area" />
                                          <option value="Carpet Area" label="Carpet Area" />
                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.pTaxLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  <div className="newGridSectionInner">
                                    <label>
                                      Rent Rate <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pTaxLogic.pTaxRentRate"
                                      />
                                      {this.validator.message(
                                        "Rent Rate",
                                        values.pTaxLogic.pTaxRentRate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Percentage of Rent <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pTaxLogic.percentageofRent"
                                      />
                                      {this.validator.message(
                                        "Percentage of Rent",
                                        values.pTaxLogic.percentageofRent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxRateTerm"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Rate Term",
                                        values.pTaxLogic.pTaxRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxFrequency"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Frequency",
                                        values.pTaxLogic.pTaxFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            onChange={(e) => handleChange(e)}
                                            name="pTaxLogic.pTaxDueDate"
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            onChange={(e) => handleChange(e)}
                                            name="pTaxLogic.pTaxDueType"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => handleChange(e)}
                                            name="pTaxLogic.pTaxDueFrequency"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pTaxLogic.pTaxDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Capped <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.ptaxCapped"
                                        onChange={(e) => {
                                          this.changePTaxCapped(e);
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="yes" label="Yes" />
                                        <option value="no" label="No" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Capped",
                                        values.pTaxLogic.ptaxCapped,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  {this.state.showPtaxCapped && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxCappedUom"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                            <option value="Flat Amount" label="Flat Amount" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Uom",
                                            values.pTaxLogic.pTaxCappedUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                      {values.pTaxLogic.pTaxCappedUom === "Per Sq Ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            P Tax Capped on Area <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="pTaxLogic.pTaxCappedOnArea"
                                              onChange={(e) => handleChange(e)}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped On Area",
                                              values.pTaxLogic.pTaxCappedOnArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped Rate <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.ptaxCappedRate"
                                          />
                                          {this.validator.message(
                                            "P Tax Capped Rate",
                                            values.pTaxLogic.ptaxCappedRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped Rate Term <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.ptaxCappedRateTerm"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Day" label="Per Day" />
                                            <option value="Per Month" label="Per Month" />
                                            <option value="Per Quarter" label="Per Quarter" />
                                            <option value="Per Half Year" label="Per Half Year" />
                                            <option value="Per Year" label="Per Year" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Rate Term",
                                            values.pTaxLogic.ptaxCappedRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}

                              {this.state.propertyTaxBasisVouchers && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pTaxLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="pTaxLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxRateTerm"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Rate Term",
                                        values.pTaxLogic.pTaxRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Type of Vouchers <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.voucherType"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="value" label="Value" />
                                        <option value="conditional" label="Conditional" />
                                        <option value="unconditional" label="Unconditional" />
                                      </Field>
                                      {this.validator.message(
                                        "Voucher Type",
                                        values.pTaxLogic.voucherType,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      Amount of Vouchers <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="pTaxLogic.voucherAmount"
                                      />
                                      {this.validator.message(
                                        "Voucher Amount",
                                        values.pTaxLogic.voucherAmount,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.pTaxFrequency"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Frequency",
                                        values.pTaxLogic.pTaxFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.pTaxDueDate"
                                            onChange={(e) => handleChange(e)}
                                          />
                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxDueType"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxDueFrequency"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.pTaxLogic.pTaxDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      P Tax Capped <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="pTaxLogic.ptaxCapped"
                                        onChange={(e) => {
                                          this.changePTaxCapped(e);
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="yes" label="Yes" />
                                        <option value="no" label="No" />
                                      </Field>
                                      {this.validator.message(
                                        "P Tax Capped",
                                        values.pTaxLogic.ptaxCapped,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  {this.state.showPtaxCapped && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.pTaxCappedUom"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                            <option value="Flat Amount" label="Flat Amount" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Uom",
                                            values.pTaxLogic.pTaxCappedUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                      {values.pTaxLogic.pTaxCappedUom === "Per Sq Ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            P Tax Capped on Area <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="pTaxLogic.pTaxCappedOnArea"
                                              onChange={(e) => handleChange(e)}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped On Area",
                                              values.pTaxLogic.pTaxCappedOnArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped Rate <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.ptaxCappedRate"
                                          />
                                          {this.validator.message(
                                            "P Tax Capped Rate",
                                            values.pTaxLogic.ptaxCappedRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                      <div className="newGridSectionInner">
                                        <label>
                                          P Tax Capped Rate Term <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="pTaxLogic.ptaxCappedRateTerm"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Day" label="Per Day" />
                                            <option value="Per Month" label="Per Month" />
                                            <option value="Per Quarter" label="Per Quarter" />
                                            <option value="Per Half Year" label="Per Half Year" />
                                            <option value="Per Year" label="Per Year" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped Rate Term",
                                            values.pTaxLogic.ptaxCappedRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}

                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_9" />
                          </div>
                        </div>
                        {this.state.showAddBtn && (
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button
                              className="add_button"
                              type="button"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.addpTaxDetails(values, resetForm, setFieldValue);
                              }}
                            >
                              Add
                            </button>
                            <button
                              className="reset_button"
                              type="reset"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.resetpTaxDetails(values, resetForm);
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        )}
                        {this.mainFormValidator.message(
                          "Property and Municipal Tax Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Property Tax Logic</th>
                                <th scope="col">Rate/ Flat Amount</th>
                                <th scope="col" colSpan="">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.propertyTaxDetails.map(function (
                                name,
                                index
                              ) {
                                return (
                                  <tr key={"pTaxTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {" "}
                                      <a
                                        className="popupLink"
                                        onClick={(e) => {
                                          this.state.popupData = name;
                                          this.openModal();
                                        }}
                                      >
                                        {name.period}
                                      </a>
                                    </td>
                                    <td>
                                      {name.periodTermYY == ""
                                        ? "0"
                                        : name.periodTermYY}
                                      {"-"}
                                      {name.periodTermMM == ""
                                        ? "0"
                                        : name.periodTermMM}
                                      {"-"}
                                      {name.periodTermDD == ""
                                        ? "0"
                                        : name.periodTermDD}
                                    </td>
                                    <td>
                                      {/* {dateFormat(name.fromDate, "dd mmm yyyy")} */}
                                      {leaseDateFormat(name.fromDate)}
                                    </td>
                                    <td>
                                      {/* {dateFormat(name.toDate, "dd mmm yyyy")} */}
                                      {leaseDateFormat(name.toDate)}
                                    </td>
                                    <td>{name.pTaxLogicText}</td>
                                    <td>
                                      {name.pTaxRentRate || name.pTaxRate || "-"}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="tableActionEdit rentalEdit"
                                        onClick={(e) => {
                                          this.editProperty(index, values);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPen} />
                                      </button>
                                      {this.state.propertyTaxDetails.length ==
                                        index + 1 && (
                                          <button
                                            type="button"
                                            className="actionDelete rentalDeleteButton"
                                            onClick={(e) => {
                                              // if (
                                              //   window.confirm(
                                              //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                              //   )
                                              // ) {
                                              //   var _pTax =
                                              //     this.state.propertyTaxDetails;
                                              //   _pTax.splice(index, 1);
                                              //   console.log(_pTax, "new array");
                                              //   this.setState({
                                              //     propertyTaxDetails: _pTax,
                                              //     showForm: true,
                                              //   });
                                              //   this.state.period--;
                                              //   if (
                                              //     this.state.propertyTaxDetails
                                              //       .length > 0
                                              //   ) {
                                              //     this.setState({
                                              //       fromDate: getToDate(
                                              //         this.state.propertyTaxDetails[
                                              //           this.state
                                              //             .propertyTaxDetails
                                              //             .length - 1
                                              //         ].toDate,
                                              //         2,
                                              //         0,
                                              //         0
                                              //       ),
                                              //     });
                                              //   } else {
                                              //     this.setState({
                                              //       fromDate: values.from,
                                              //     });
                                              //   }
                                              // }
                                              this.setState({
                                                delete: true,
                                                index_val: index,
                                                revalue: values.from,
                                              });

                                              this.handleReset();
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                );
                              },
                                this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>


                  {/* <Form className="customTabs">
                    <div className="newGridSectionParent">
                      <div className="unitFormContainerNew leaseSection">
                        <div className="row m-0">
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lease Term (YY-MM-DD){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-3 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />
                                </div>
                                <ErrorMessage
                                  name="leaseTerm"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lease Renewal Term (YY-MM-DD){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-3 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                  />
                                </div>
                                <ErrorMessage
                                  name="leaseRenewalTerm"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row m-0">
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  From
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="from" />
                                  <ErrorMessage
                                    name="from"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  To
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="to" />
                                  <ErrorMessage
                                    name="to"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Property Tax Payable By
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field
                                    as="select"
                                    name={"propertyTaxPayable"}
                                    value={this.state.applicableValue}
                                    onChange={(e) => {
                                      this.state.applicableValue = e.target.value;
                                      handleChange(e);
                                      this.showpTaxForm(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option value="yes" label="Occupier" />
                                    <option value="no" label="Landlord" />
                                  </Field>
                                  {this.applicableValidator.message(
                                    "Property Tax Payable By",
                                    this.state.applicableValue,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {this.state.togglepTaxForm && (
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Property Tax Bases
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as="select"
                                      name={"pTaxLogic.propertyTaxBasis"}
                                      value={this.state.propertyTaxBasisValue}
                                      disabled={this.state.disableOnEdit}
                                      onChange={(e) => {
                                        this.getpTaxLogicValues(e);
                                        this.state.propertyTaxBasisValue =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Property Tax Basis Rate"
                                        label="Property Tax Basis Rate"
                                      />
                                      <option
                                        value="Property Tax Basis Actuals"
                                        label="Property Tax Basis Actuals"
                                      />
                                    </Field>

                                    {this.validator.message(
                                      "Property Tax Bases",
                                      this.state.propertyTaxBasisValue,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>



                        {this.state.togglepTaxForm && (
                          <div className="pTaxPayable">
                            <div className="row m-0">
                              {this.state.showForm && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="text"
                                          name="pTaxLogic.period"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.period}
                                          onChange={(e) => {
                                            this.state.period = e.target.value;
                                          }}
                                        />
                                        <ErrorMessage
                                          name="pTaxLogic.period"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {this.state.showForm && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period Term
                                      </label>
                                      <div className="col-sm-3 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="periodTermmYY"
                                          placeholder="YY"
                                          disabled={this.state.disableOnEdit}
                                          className="centerPlaceHolder text-center"
                                          value={this.state.periodTermYY}
                                          onChange={(e) => {
                                            this.state.periodTermYY =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="periodTermMM"
                                          placeholder="MM"
                                          disabled={this.state.disableOnEdit}
                                          className="centerPlaceHolder text-center"
                                          value={this.state.periodTermMM}
                                          onChange={(e) => {
                                            this.state.periodTermMM =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="periodTermDD"
                                          placeholder="DD"
                                          disabled={this.state.disableOnEdit}
                                          className="centerPlaceHolder text-center"
                                          value={this.state.periodTermDD}
                                          onChange={(e) => {
                                            this.state.periodTermDD =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <ErrorMessage
                                        name="pTaxLogic.periodTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            {this.state.showForm && (
                              <div className="row mb-4">
                                <div className="col-lg-12">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row m-0">
                                      <label className="col-sm-2 col-form-label">
                                        Property Tax Logic{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-10 logicDropdownWidthDesktop">
                                        <Field
                                          as="select"
                                          name={"pTaxLogic.pTaxLogicValue"}
                                          disabled={this.state.disableOnEdit}
                                          value={
                                            this.state.initialValues.pTaxLogic
                                              .pTaxLogicValue
                                          }
                                          onChange={(e) => {
                                            handleChange(e);
                                            this.hadlepTaxLogicChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          {this.state.pTaxLogicValues.map(
                                            (item, i) => (
                                              <option
                                                key={"pTaxLogicValues" + item}
                                                value={i + 1}
                                              >
                                                {item}
                                              </option>
                                            )
                                          )}
                                        </Field>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.propertyTaxBasisRate && (
                              <div className="propertyTaxBasisRate">
                                <div className="row m-0">
                                  {this.state.disableOnActual == false && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            From <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="date"
                                              readOnly={true}
                                              name="pTaxLogic.fromDate"
                                              value={this.state.fromDate}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            {this.validator.message(
                                              "From",
                                              this.state.fromDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.disableOnActual == false && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="date"
                                              readOnly={true}
                                              name="pTaxLogic.toDate"
                                              value={this.state.toDate}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            {this.validator.message(
                                              "To",
                                              this.state.toDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.disableOnActual == false && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P TAX UOM{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxUom"}
                                              // disabled={this.state.disableOnActual}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P TAX UOM",
                                              values.pTaxLogic.pTaxUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {values.pTaxLogic.pTaxUom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.onArea"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Usable Area"
                                                label="Usable Area"
                                              />
                                              <option
                                                value="Carpet Area"
                                                label="Carpet Area"
                                              />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.pTaxLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.period > 1 &&
                                    typeof this.state.propertyTaxDetails[
                                      this.state.escalationIndex
                                    ].pTaxRate !== "undefined" &&
                                    this.state.propertyTaxDetails[
                                      this.state.escalationIndex
                                    ].pTaxRate !== 0 &&
                                    this.state.disableOnActual === false && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Escalation %
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="pTaxLogic.escalationPercent"
                                                disabled={
                                                  this.state.disableOnEdit
                                                }
                                                onBlur={(e) => {
                                                  this.calculateRentRate(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.pTaxLogic
                                                  .escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  {this.state.disableOnActual == false && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P TAX Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.pTaxRate"
                                              onBlur={(e) => {
                                                this.calculateEscalationPercent(
                                                  e,
                                                  values,
                                                  setFieldValue
                                                );
                                              }}
                                            // disabled={this.state.disableOnActual}
                                            />
                                            {this.validator.message(
                                              "p Tax Rate",
                                              values.pTaxLogic.pTaxRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P TAX Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Rate Term",
                                            values.pTaxLogic.pTaxRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P TAX Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Frequency",
                                            values.pTaxLogic.pTaxFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P TAX Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pTaxLogic.pTaxDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.ptaxCapped"}
                                            onChange={(e) => {
                                              this.changePTaxCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="yes" label="Yes" />
                                            <option value="no" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped",
                                            values.pTaxLogic.ptaxCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showPtaxCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Uom",
                                              values.pTaxLogic.pTaxCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.pTaxLogic.pTaxCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                P Tax Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "pTaxLogic.pTaxCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "P Tax Capped On Area",
                                                  values.pTaxLogic.pTaxCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.ptaxCappedRate"
                                            />
                                            {this.validator.message(
                                              "P Tax Capped Rate",
                                              values.pTaxLogic.ptaxCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "pTaxLogic.ptaxCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Day"
                                                label="Per Day"
                                              />
                                              <option
                                                value="Per Month"
                                                label="Per Month"
                                              />
                                              <option
                                                value="Per Quarter"
                                                label="Per Quarter"
                                              />
                                              <option
                                                value="Per Half Year"
                                                label="Per Half Year"
                                              />
                                              <option
                                                value="Per Year"
                                                label="Per Year"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Rate Term",
                                              values.pTaxLogic.ptaxCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}





                                {this.state.disableOnActual && (
                                  <div className="unitFormContainer leaseSection utilities rates mt-0">
                                    <div className="container">
                                      <div className="row m-0">
                                        {this.state.showFirstAddBtn == true && (
                                          <div className="col-lg-12 text-center">
                                            <button
                                              type="button"
                                              className="ratesAddbutton mb-2"
                                              onClick={(e) => {
                                                this.addRatesRow();
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faPlus} />{" "}
                                              Add Rates
                                            </button>
                                          </div>
                                        )}
                                        <div className="col-lg-12">
                                          {this.state.initialValues.pTaxLogic
                                            .rates !== undefined &&
                                            this.state.initialValues.pTaxLogic.rates.map(
                                              (name, index) => (
                                                <div className="row m-0">
                                                  <div className="col-lg-4">
                                                    <div className="inputContainer col-lg-12 col-md-12">
                                                      <div className="row mb-3">
                                                        <label className="col-sm-2 col-form-label">
                                                          From
                                                        </label>
                                                        <div className="col-sm-10">
                                                          <Field
                                                            type="date"
                                                            name={`pTaxLogic.rates.${index}.from`}
                                                            onChange={(e) => {
                                                              this.state.initialValues.pTaxLogic.rates[
                                                                index
                                                              ].from =
                                                                e.target.value;
                                                              handleChange(e);
                                                            }}
                                                            value={
                                                              this.state
                                                                .initialValues
                                                                .pTaxLogic.rates[
                                                                index
                                                              ].from
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-4">
                                                    <div className="inputContainer col-lg-12 col-md-12">
                                                      <div className="row mb-3">
                                                        <label className="col-sm-2 col-form-label">
                                                          To
                                                        </label>
                                                        <div className="col-sm-10">
                                                          <Field
                                                            type="date"
                                                            name={`pTaxLogic.rates.${index}.to`}
                                                            value={
                                                              this.state
                                                                .initialValues
                                                                .pTaxLogic.rates[
                                                                index
                                                              ].to
                                                            }
                                                            onChange={(e) => {
                                                              this.state.initialValues.pTaxLogic.rates[
                                                                index
                                                              ].to =
                                                                e.target.value;
                                                              handleChange(e);
                                                            }}
                                                            onBlur={(e) => {
                                                              console.log("hh");
                                                              if (
                                                                index <
                                                                this.state
                                                                  .initialValues
                                                                  .pTaxLogic.rates
                                                                  .length -
                                                                1
                                                              ) {
                                                                this.getRatesFromForNextSlab(
                                                                  e,
                                                                  values,
                                                                  index
                                                                );
                                                              }
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-4">
                                                    <div className="inputContainer col-lg-12 col-md-12">
                                                      <div className="row mb-3">
                                                        <label className="col-sm-2 col-form-label">
                                                          P TAX UOM{" "}
                                                        </label>
                                                        <div className="col-sm-10">
                                                          <Field
                                                            as="select"
                                                            name={`pTaxLogic.rates.${index}.pTaxUom`}
                                                            onChange={(e) => {
                                                              this.showRatesOnarea(
                                                                e,
                                                                index
                                                              );
                                                              this.state.initialValues.pTaxLogic.rates[
                                                                index
                                                              ].pTaxUom =
                                                                e.target.value;
                                                              handleChange(e);
                                                            }}
                                                            value={
                                                              this.state
                                                                .initialValues
                                                                .pTaxLogic.rates[
                                                                index
                                                              ].pTaxUom
                                                            }
                                                          >
                                                            <option
                                                              value=""
                                                              label="Select"
                                                              defaultValue
                                                            />
                                                            <option
                                                              value="Per Sq Ft"
                                                              label="Per Sq Ft"
                                                            />
                                                            <option
                                                              value="Flat Amount"
                                                              label="Flat Amount"
                                                            />
                                                          </Field>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  {this.state.showRatesOnarea[
                                                    index
                                                  ] !== undefined &&
                                                    this.state.showRatesOnarea[
                                                    index
                                                    ] && (
                                                      <div className="col-lg-4">
                                                        <div className="inputContainer col-lg-12 col-md-12">
                                                          <div className="row mb-3">
                                                            <label className="col-sm-2 col-form-label">
                                                              On Area
                                                            </label>
                                                            <div className="col-sm-10">
                                                              <Field
                                                                as="select"
                                                                name={`pTaxLogic.rates.${index}.onArea`}
                                                                onChange={(e) => {
                                                                  this.state.initialValues.pTaxLogic.rates[
                                                                    index
                                                                  ].onArea =
                                                                    e.target.value;
                                                                  handleChange(e);
                                                                }}
                                                                value={
                                                                  this.state
                                                                    .initialValues
                                                                    .pTaxLogic
                                                                    .rates[index]
                                                                    .onArea
                                                                }
                                                              >
                                                                <option
                                                                  value=""
                                                                  label="Select"
                                                                  defaultValue
                                                                />
                                                                <option
                                                                  value="Usable Area"
                                                                  label="Usable Area"
                                                                />
                                                                <option
                                                                  value="Carpet Area"
                                                                  label="Carpet Area"
                                                                />
                                                                <option
                                                                  value="Gross Leasable Area"
                                                                  label="Gross Leasable Area"
                                                                />
                                                              </Field>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  <div className="col-lg-4">
                                                    <div className="inputContainer col-lg-12 col-md-12">
                                                      <div className="row mb-3">
                                                        <label className="col-sm-2 col-form-label">
                                                          Rate
                                                        </label>
                                                        <div className="col-sm-10">
                                                          <Field
                                                            type="text"
                                                            name={`pTaxLogic.rates.${index}.rate`}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-4">
                                                    <span
                                                      className="ratesAdd me-2"
                                                      onClick={(e) => {
                                                        this.addRatesRow();
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faPlus}
                                                      />
                                                    </span>
                                                    <span
                                                      className="ratesRemove"
                                                      onClick={(e) => {
                                                        this.removeRatesRow();
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTimes}
                                                      />
                                                    </span>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {this.state.propertyTaxBasisPureRevenueShare && (
                              <div className="propertyTaxBasisPureRevenueShare">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pTaxLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pTaxLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            name="pTaxLogic.revenueShare"
                                            type="number"
                                          // value={this.state}
                                          />
                                          {this.validator.message(
                                            "Revenue Share",
                                            values.pTaxLogic.revenueShare,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P TAX Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Rate Term",
                                            values.pTaxLogic.pTaxRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P TAX Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Frequency",
                                            values.pTaxLogic.pTaxFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P TAX Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pTaxLogic.pTaxDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.ptaxCapped"}
                                            onChange={(e) => {
                                              this.changePTaxCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="yes" label="Yes" />
                                            <option value="no" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped",
                                            values.pTaxLogic.ptaxCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showPtaxCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Uom",
                                              values.pTaxLogic.pTaxCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.pTaxLogic.pTaxCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                P Tax Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "pTaxLogic.pTaxCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "P Tax Capped On Area",
                                                  values.pTaxLogic.pTaxCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.ptaxCappedRate"
                                            />
                                            {this.validator.message(
                                              "P Tax Capped Rate",
                                              values.pTaxLogic.ptaxCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "pTaxLogic.ptaxCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Day"
                                                label="Per Day"
                                              />
                                              <option
                                                value="Per Month"
                                                label="Per Month"
                                              />
                                              <option
                                                value="Per Quarter"
                                                label="Per Quarter"
                                              />
                                              <option
                                                value="Per Half Year"
                                                label="Per Half Year"
                                              />
                                              <option
                                                value="Per Year"
                                                label="Per Year"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Rate Term",
                                              values.pTaxLogic.ptaxCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {this.state
                              .propertyTaxBasisPureRevenueShareSalesRange && (
                                <div className="propertyTaxBasisPureRevenueShareSalesRange">
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            From <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="date"
                                              name="pTaxLogic.fromDate"
                                              value={this.state.fromDate}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            {this.validator.message(
                                              "From",
                                              this.state.fromDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="date"
                                              name="pTaxLogic.toDate"
                                              value={this.state.toDate}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            {this.validator.message(
                                              "To",
                                              this.state.toDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-12 p-0">
                                      <div className="gridColOneByThree textWithHrTag bigFonrSize">
                                        <h4>P Tax Revenue Share (%)</h4>
                                        <hr className="m-0" />
                                      </div>
                                      <div className="tableContainer p-0">
                                        <div className="col-lg-6 mb-4 p-0">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row m-0">
                                              <label className="col-sm-3 ps-0 col-form-label">
                                                No. of SLABS{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-sm-7 pe-0">
                                                <Field
                                                  type="text"
                                                  name="pTaxLogic.slabNumber"
                                                  value={
                                                    this.state.initialValues
                                                      .totalSlabs
                                                  }
                                                  className="slabInput"
                                                  onChange={(e) => {
                                                    this.addSlabRow(e);
                                                    handleChange(e);
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name="pTaxLogic.slabNumber"
                                                  component="div"
                                                  className="text-red"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <table className="table tableSimple">
                                          <thead>
                                            <tr>
                                              <th scope="col">SLAB</th>
                                              <th scope="col">FROM</th>
                                              <th scope="col">To</th>
                                              <th scope="col">
                                                P Tax Revenue Share (%)
                                              </th>
                                              <th scope="col" colSpan="">
                                                Action
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.initialValues
                                              .pTaxLogic.slabs.length > 0 &&
                                              this.state.initialValues.pTaxLogic.slabs.map(
                                                (friend, index) => (
                                                  <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`pTaxLogic.slabs.${index}.from`}
                                                        onChange={(e) => {
                                                          this.state.initialValues.pTaxLogic.slabs[
                                                            index
                                                          ].from =
                                                            e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state
                                                            .initialValues
                                                            .pTaxLogic.slabs[
                                                            index
                                                          ].from
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`pTaxLogic.slabs.${index}.to`}
                                                        onChange={(e) => {
                                                          this.state.initialValues.pTaxLogic.slabs[
                                                            index
                                                          ].to =
                                                            e.target.value;
                                                          handleChange(e);
                                                        }}
                                                        value={
                                                          this.state
                                                            .initialValues
                                                            .pTaxLogic.slabs[
                                                            index
                                                          ].to
                                                        }
                                                        onBlur={(e) => {
                                                          if (
                                                            index <
                                                            this.state
                                                              .initialValues
                                                              .pTaxLogic.slabs
                                                              .length -
                                                            1
                                                          ) {
                                                            this.getFromForNextSlab(
                                                              e,
                                                              values,
                                                              index
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="text"
                                                        name={`pTaxLogic.slabs.${index}.percent`}
                                                      />
                                                    </td>
                                                    <td>
                                                      <a
                                                        className="actionDelete"
                                                        href="#"
                                                        onClick={() => {
                                                          this.state
                                                            .initialValues
                                                            .totalSlabs--;
                                                          var _slabs =
                                                            this.state
                                                              .initialValues
                                                              .pTaxLogic
                                                              .slabs;
                                                          _slabs.splice(
                                                            index,
                                                            1
                                                          );
                                                          this.setState({
                                                            slabs: _slabs,
                                                          });
                                                        }}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faTimes}
                                                        />
                                                      </a>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P TAX Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxRateTerm"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Month"
                                                label="Per Month"
                                              />
                                              <option
                                                value="Per Quarter"
                                                label="Per Quarter"
                                              />
                                              <option
                                                value="Per Half Year"
                                                label="Per Half Year"
                                              />
                                              <option
                                                value="Per Year"
                                                label="Per Year"
                                              />
                                              <option
                                                value="Per Day"
                                                label="Per Day"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "p Tax Rate Term",
                                              values.pTaxLogic.pTaxRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P TAX Frequency
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxFrequency"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option value="Daily" label="Daily" />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "p Tax Frequency",
                                              values.pTaxLogic.pTaxFrequency,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P TAX Due Date{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-3 dueDateFieldWidth">
                                            <Field
                                              type="number"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              name="pTaxLogic.pTaxDueDate"
                                            ></Field>
                                          </div>
                                          <div className="col-sm-3 dueDateFieldWidth">
                                            <Field
                                              as="select"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              name="pTaxLogic.pTaxDueType"
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option value="Date" label="Date" />
                                              <option value="Days" label="Days" />
                                              <option
                                                value="Working Day"
                                                label="Working Day"
                                              />
                                            </Field>
                                          </div>
                                          <div className="col-sm-7 offset-sm-4 mt-3">
                                            <Field
                                              as="select"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              name="pTaxLogic.pTaxDueFrequency"
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Every Month"
                                                label="Every Month"
                                              />
                                              <option
                                                value="Subsequent Month"
                                                label="Subsequent Month"
                                              />
                                              <option
                                                value="Subsequent Quarter"
                                                label="Subsequent Quarter"
                                              />
                                              <option
                                                value="Subsequent Half Year"
                                                label="Subsequent Half Year"
                                              />
                                              <option
                                                value="Subsequent Year"
                                                label="Subsequent Year"
                                              />
                                              <option
                                                value="Next Financial Year"
                                                label="Next Financial Year"
                                              />
                                            </Field>
                                          </div>
                                          <div className="col-sm-7 offset-sm-4">
                                            {this.validator.message(
                                              "Due Date",
                                              values.pTaxLogic.pTaxDueDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.ptaxCapped"}
                                              onChange={(e) => {
                                                this.changePTaxCapped(e);
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option value="yes" label="Yes" />
                                              <option value="no" label="No" />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped",
                                              values.pTaxLogic.ptaxCapped,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>



                                  {this.state.showPtaxCapped && (
                                    <div className="row m-0">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              P Tax Capped UOM
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                as="select"
                                                name={"pTaxLogic.pTaxCappedUom"}
                                                onChange={(e) => {
                                                  this.validator =
                                                    new SimpleReactValidator({
                                                      autoForceUpdate: this,
                                                    });
                                                  handleChange(e);
                                                }}
                                              >
                                                <option
                                                  value=""
                                                  label="Select"
                                                  defaultValue
                                                />
                                                <option
                                                  value="Per Sq Ft"
                                                  label="Per Sq Ft"
                                                />
                                                <option
                                                  value="Flat Amount"
                                                  label="Flat Amount"
                                                />
                                              </Field>
                                              {this.validator.message(
                                                "P Tax Capped Uom",
                                                values.pTaxLogic.pTaxCappedUom,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {values.pTaxLogic.pTaxCappedUom ==
                                        "Per Sq Ft" && (
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  P Tax Capped on Area
                                                  <span className="astrik">*</span>
                                                </label>
                                                <div className="col-sm-7">
                                                  <Field
                                                    as="select"
                                                    name={
                                                      "pTaxLogic.pTaxCappedOnArea"
                                                    }
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                  >
                                                    <option
                                                      value=""
                                                      label="Select"
                                                      defaultValue
                                                    />
                                                    <option
                                                      value="Usable Area"
                                                      label="Usable Area"
                                                    />
                                                    <option
                                                      value="Carpet Area"
                                                      label="Carpet Area"
                                                    />
                                                    <option
                                                      value="Gross Leasable Area"
                                                      label="Gross Leasable Area"
                                                    />
                                                  </Field>
                                                  {this.validator.message(
                                                    "P Tax Capped On Area",
                                                    values.pTaxLogic.pTaxCappedOnArea,
                                                    "required",
                                                    { className: "text-danger" }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              P Tax Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="pTaxLogic.ptaxCappedRate"
                                              />
                                              {this.validator.message(
                                                "P Tax Capped Rate",
                                                values.pTaxLogic.ptaxCappedRate,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              P Tax Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                as="select"
                                                name={
                                                  "pTaxLogic.ptaxCappedRateTerm"
                                                }
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                              >
                                                <option
                                                  value=""
                                                  label="Select"
                                                  defaultValue
                                                />
                                                <option
                                                  value="Per Day"
                                                  label="Per Day"
                                                />
                                                <option
                                                  value="Per Month"
                                                  label="Per Month"
                                                />
                                                <option
                                                  value="Per Quarter"
                                                  label="Per Quarter"
                                                />
                                                <option
                                                  value="Per Half Year"
                                                  label="Per Half Year"
                                                />
                                                <option
                                                  value="Per Year"
                                                  label="Per Year"
                                                />
                                              </Field>
                                              {this.validator.message(
                                                "P Tax Capped Rate Term",
                                                values.pTaxLogic.ptaxCappedRateTerm,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            {this.state.propertyTaxBasisPercentofRent && (
                              <div className="propertyTaxBasisPercentofRent">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pTaxLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pTaxLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxUom"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                            <option
                                              value="Flat Amount"
                                              label="Flat Amount"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Rent Uom",
                                            values.pTaxLogic.pTaxUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.pTaxLogic.pTaxUom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.onArea"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Usable Area"
                                                label="Usable Area"
                                              />
                                              <option
                                                value="Carpet Area"
                                                label="Carpet Area"
                                              />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.pTaxLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.pTaxRentRate"
                                          />
                                          {this.validator.message(
                                            "Rent Rate",
                                            values.pTaxLogic.pTaxRentRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Percentage of Rent
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.percentageofRent"
                                          />
                                          {this.validator.message(
                                            "percentage of Rent",
                                            values.pTaxLogic.percentageofRent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Rate Term",
                                            values.pTaxLogic.pTaxRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Frequency",
                                            values.pTaxLogic.pTaxFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pTaxLogic.pTaxDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.ptaxCapped"}
                                            onChange={(e) => {
                                              this.changePTaxCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="yes" label="Yes" />
                                            <option value="no" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped",
                                            values.pTaxLogic.ptaxCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showPtaxCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Uom",
                                              values.pTaxLogic.pTaxCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.pTaxLogic.pTaxCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                P Tax Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "pTaxLogic.pTaxCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "P Tax Capped On Area",
                                                  values.pTaxLogic.pTaxCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.ptaxCappedRate"
                                            />
                                            {this.validator.message(
                                              "P Tax Capped Rate",
                                              values.pTaxLogic.ptaxCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "pTaxLogic.ptaxCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Day"
                                                label="Per Day"
                                              />
                                              <option
                                                value="Per Month"
                                                label="Per Month"
                                              />
                                              <option
                                                value="Per Quarter"
                                                label="Per Quarter"
                                              />
                                              <option
                                                value="Per Half Year"
                                                label="Per Half Year"
                                              />
                                              <option
                                                value="Per Year"
                                                label="Per Year"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Rate Term",
                                              values.pTaxLogic.ptaxCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}


                            {this.state.propertyTaxBasisVouchers && (
                              <div className="propertyTaxBasisVouchers">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pTaxLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="pTaxLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Rate Term",
                                            values.pTaxLogic.pTaxRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Type of Vouchers
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.voucherType"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="value" label="Value" />
                                            <option
                                              value="conditional"
                                              label="Conditional"
                                            />
                                            <option
                                              value="unconditional"
                                              label="Unconditional"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "voucher Type",
                                            values.pTaxLogic.voucherType,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Amount of Vouchers{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="pTaxLogic.voucherAmount"
                                          />
                                          {this.validator.message(
                                            "voucher Amount",
                                            values.pTaxLogic.voucherAmount,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.pTaxFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "p Tax Frequency",
                                            values.pTaxLogic.pTaxFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="pTaxLogic.pTaxDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.pTaxLogic.pTaxDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          P Tax Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"pTaxLogic.ptaxCapped"}
                                            onChange={(e) => {
                                              this.changePTaxCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="yes" label="Yes" />
                                            <option value="no" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "P Tax Capped",
                                            values.pTaxLogic.ptaxCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>




                                {this.state.showPtaxCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"pTaxLogic.pTaxCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Uom",
                                              values.pTaxLogic.pTaxCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.pTaxLogic.pTaxCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                P Tax Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={
                                                    "pTaxLogic.pTaxCappedOnArea"
                                                  }
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "P Tax Capped On Area",
                                                  values.pTaxLogic.pTaxCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="pTaxLogic.ptaxCappedRate"
                                            />
                                            {this.validator.message(
                                              "P Tax Capped Rate",
                                              values.pTaxLogic.ptaxCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            P Tax Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={
                                                "pTaxLogic.ptaxCappedRateTerm"
                                              }
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Day"
                                                label="Per Day"
                                              />
                                              <option
                                                value="Per Month"
                                                label="Per Month"
                                              />
                                              <option
                                                value="Per Quarter"
                                                label="Per Quarter"
                                              />
                                              <option
                                                value="Per Half Year"
                                                label="Per Half Year"
                                              />
                                              <option
                                                value="Per Year"
                                                label="Per Year"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "P Tax Capped Rate Term",
                                              values.pTaxLogic.ptaxCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}




                        {this.state.showAddBtn && (
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button
                              className="add_button"
                              type="button"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.addpTaxDetails(values, resetForm, setFieldValue);
                              }}
                            >
                              Add
                            </button>
                            <button
                              className="reset_button"
                              type="reset"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.resetpTaxDetails(values, resetForm);
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        )}
                        <span className="remarks">Notes/Remarks</span>
                        <Field as="textarea" className="notes mb-3" name="notes_9" />
                      </div>
                      {this.mainFormValidator.message(
                        "Property and Municipal Tax Details",
                        this.countError,
                        "required",
                        { className: "text-danger" }
                      )}
                      <div className="tableContainer p-0">
                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Period</th>
                              <th scope="col">Period Term</th>
                              <th scope="col">From</th>
                              <th scope="col">To</th>
                              <th scope="col">Property Tax Logic</th>
                              <th scope="col">Rate/ Flat Amount</th>
                              <th scope="col" colSpan="">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.propertyTaxDetails.map(function (
                              name,
                              index
                            ) {
                              return (
                                <tr key={"pTaxTable" + index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {" "}
                                    <a
                                      className="popupLink"
                                      onClick={(e) => {
                                        this.state.popupData = name;
                                        this.openModal();
                                      }}
                                    >
                                      {name.period}
                                    </a>
                                  </td>
                                  <td>
                                    {name.periodTermYY == ""
                                      ? "0"
                                      : name.periodTermYY}
                                    {"-"}
                                    {name.periodTermMM == ""
                                      ? "0"
                                      : name.periodTermMM}
                                    {"-"}
                                    {name.periodTermDD == ""
                                      ? "0"
                                      : name.periodTermDD}
                                  </td>
                                  <td>
                                    {leaseDateFormat(name.fromDate)}
                                  </td>
                                  <td>
                                    {leaseDateFormat(name.toDate)}
                                  </td>
                                  <td>{name.pTaxLogicText}</td>
                                  <td>
                                    {name.pTaxRentRate || name.pTaxRate || "-"}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="tableActionEdit rentalEdit"
                                      onClick={(e) => {
                                        this.editProperty(index, values);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPen} />
                                    </button>
                                    {this.state.propertyTaxDetails.length ==
                                      index + 1 && (
                                        <button
                                          type="button"
                                          className="actionDelete rentalDeleteButton"
                                          onClick={(e) => {
                                            // if (
                                            //   window.confirm(
                                            //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                            //   )
                                            // ) {
                                            //   var _pTax =
                                            //     this.state.propertyTaxDetails;
                                            //   _pTax.splice(index, 1);
                                            //   console.log(_pTax, "new array");
                                            //   this.setState({
                                            //     propertyTaxDetails: _pTax,
                                            //     showForm: true,
                                            //   });
                                            //   this.state.period--;
                                            //   if (
                                            //     this.state.propertyTaxDetails
                                            //       .length > 0
                                            //   ) {
                                            //     this.setState({
                                            //       fromDate: getToDate(
                                            //         this.state.propertyTaxDetails[
                                            //           this.state
                                            //             .propertyTaxDetails
                                            //             .length - 1
                                            //         ].toDate,
                                            //         2,
                                            //         0,
                                            //         0
                                            //       ),
                                            //     });
                                            //   } else {
                                            //     this.setState({
                                            //       fromDate: values.from,
                                            //     });
                                            //   }
                                            // }
                                            this.setState({
                                              delete: true,
                                              index_val: index,
                                              revalue: values.from,
                                            });

                                            this.handleReset();
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                      )}
                                  </td>
                                </tr>
                              );
                            },
                              this)}
                          </tbody>
                        </table>
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button type="submit" className="add_button">
                            Save Draft
                          </button>
                          <button type="reset" className="reset_button">
                            <Link to="/createlease">
                              Cancel
                            </Link>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form> */}
                </>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row m-0">
                        <div className="col-lg-12">
                          <ul>
                            <li>Property & Muncipal Tax Fund</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.pTaxPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }
  pTaxPopup(pTax) {
    console.log(pTax);
    if (
      pTax.pTaxLogicValue == 1 &&
      pTax.pTaxLogicText == "Property Tax Basis Rate"
    ) {
      return this.pTaxBasisRatePopup(pTax);
    } else if (
      pTax.pTaxLogicValue == 1 &&
      pTax.pTaxLogicText == "Property Tax Basis Actual"
    ) {
      return this.pTaxBasisActualPopup(pTax);
    } else if (pTax.pTaxLogicValue == 2) {
      return this.pTaxBasisRatePureRevenueSharePopup(pTax);
    } else if (pTax.pTaxLogicValue == 3) {
      return this.pTaxBasisRatePureRevenueShareSalesRangePopup(pTax);
    } else if (pTax.pTaxLogicValue == 4) {
      return this.pTaxBasisPercentOfRentPopup(pTax);
    } else if (pTax.pTaxLogicValue == 5) {
      return this.pTaxBasisVouchersPopup(pTax);
    }
  }

  pTaxBasisRatePopup(pTax) {
    return (
      <div className="container">
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.periodTermYY == "" ? "0" : pTax.periodTermYY}
                  {"-"}
                  {pTax.periodTermMM == "" ? "0" : pTax.periodTermMM}
                  {"-"}
                  {pTax.periodTermDD == "" ? "0" : pTax.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Property and Municipal Tax Logic{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.ptaxCapped}
                </label>
              </div>
            </div>
          </div>
          {pTax.ptaxCapped == "yes" && (
            <div className="pTaxCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  pTaxBasisActualPopup(pTax) {
    return (
      <div className="container">
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.periodTermYY == "" ? "0" : pTax.periodTermYY}
                  {"-"}
                  {pTax.periodTermMM == "" ? "0" : pTax.periodTermMM}
                  {"-"}
                  {pTax.periodTermDD == "" ? "0" : pTax.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Property and Municipal Tax Logic{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>

        {pTax.rates != undefined && (
          <div className="row m-0">
            {pTax.rates.map(function (name, index) {
              return (
                <div className="row rateRow">
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          From <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {leaseDateFormat(name.from)}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          To <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {leaseDateFormat(name.to)}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          PTax UOM <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.pTaxUom}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          On Area <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.onArea}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          Rate <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.rate}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }, this)}
          </div>
        )}
      </div>
    );
  }

  pTaxBasisRatePureRevenueSharePopup(pTax) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.periodTermYY == "" ? "0" : pTax.periodTermYY}
                  {"-"}
                  {pTax.periodTermMM == "" ? "0" : pTax.periodTermMM}
                  {"-"}
                  {pTax.periodTermDD == "" ? "0" : pTax.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Property and Municipal Tax Logic{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.ptaxCapped}
                </label>
              </div>
            </div>
          </div>
          {pTax.ptaxCapped == "yes" && (
            <div className="pTaxCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  pTaxBasisRatePureRevenueShareSalesRangePopup(pTax) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.periodTermYY == "" ? "0" : pTax.periodTermYY}
                  {"-"}
                  {pTax.periodTermMM == "" ? "0" : pTax.periodTermMM}
                  {"-"}
                  {pTax.periodTermDD == "" ? "0" : pTax.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Property and Municipal Tax Logic{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer p-0">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pTax.slabs.length > 0 &&
                          pTax.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.ptaxCapped}
                </label>
              </div>
            </div>
          </div>
          {pTax.ptaxCapped == "yes" && (
            <div className="pTaxCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  pTaxBasisPercentOfRentPopup(pTax) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.periodTermYY == "" ? "0" : pTax.periodTermYY}
                  {"-"}
                  {pTax.periodTermMM == "" ? "0" : pTax.periodTermMM}
                  {"-"}
                  {pTax.periodTermDD == "" ? "0" : pTax.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Property and Municipal Tax Logic{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRentUom}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRentRate}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Percentage of Rent <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.percentageofRent}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.ptaxCapped}
                </label>
              </div>
            </div>
          </div>
          {pTax.ptaxCapped == "yes" && (
            <div className="pTaxCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  pTaxBasisVouchersPopup(pTax) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{pTax.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.periodTermYY == "" ? "0" : pTax.periodTermYY}
                  {"-"}
                  {pTax.periodTermMM == "" ? "0" : pTax.periodTermMM}
                  {"-"}
                  {pTax.periodTermDD == "" ? "0" : pTax.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Property and Municipal Tax Logic{" "}
                  <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(pTax.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Type of Vouchers <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.voucherType}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Amount of Vouchers <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.voucherAmount}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.pTaxDueDate}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  PTax Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {pTax.ptaxCapped}
                </label>
              </div>
            </div>
          </div>
          {pTax.ptaxCapped == "yes" && (
            <div className="pTaxCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.pTaxCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      PTax Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {pTax.ptaxCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(PropertyMuncipalTax);
